'use strict';

export function searchAddresses(expression, country, onSuccess, onFailed) {
    let route = '';

    if (typeof country === "undefined") {
        route = 'https://photon.komoot.io/api/?q=' + expression + '&limit=7&lang=fr';
    } else if (country.toUpperCase() === 'FRANCE') {
        route = 'https://api-adresse.data.gouv.fr/search?q=' + expression + '&limit=7';
    } else {
         route = 'https://photon.komoot.io/api/?q=' + expression + ' ' + country + '&limit=7&lang=fr';
    }
    
    const xmlhttp = new XMLHttpRequest();

    xmlhttp.onreadystatechange = function () {
        if (this.readyState !== 4) return;

        if (this.status === 200) {
            const response = JSON.parse(this.responseText);
            onSuccess(response);
        } else {
            onFailed();
        }
    };

    xmlhttp.open('GET', route, true);
    xmlhttp.setRequestHeader('Content-Type', 'application/json');
    xmlhttp.send();
}
